/**
 * d16n::legacy
 * d16n::source:PProductDetail.vue
 * d16n::helpers-file
 */

import { useProductCard } from '@b2ag/catalog/src/useProductCard'

/**
 * @FIXME d16n::legacy Was Object
 */
type Product = Record<string, any>

export function useSellableAssociatedProducts(product: Product) {
  const associatedProducts = product.associatedProducts?.filter((associatedProduct) => associatedProduct.sellable)
  return associatedProducts?.map(({ _id }) => {
    const { product: productCard, isOffSeasonProduct } = useProductCard(_id)
    return { ...productCard.value, isOffSeasonProduct: isOffSeasonProduct.value }
  })
}

export function useSupplierRelatedSearchUrl(
  product: Product,
  router: any,
  getSlugFromCategories: (categories: string[]) => string,
): string | undefined {
  const canonicalCategory = product.categories[0]
  const rawFilters = {
    'menu[supplier]': product.supplier,
  }
  const filtersWithoutUndefined = JSON.parse(JSON.stringify(rawFilters))
  return router?.resolve({
    name: 'category',
    query: filtersWithoutUndefined,
    params: {
      slug: getSlugFromCategories(canonicalCategory.map((category) => category.label)),
    },
  })?.href
}
